import { createContext, useContext } from 'react';

export type ObjectMap = {
  [key: string]: string | undefined;
};

/** context for feature Flag */
export const featureFlagContext = createContext<
  IFeatureFlagContext | undefined
>(undefined);

/** Hook to access 'featureFlagContext' Data.
 */
export function useFeatureFlagContext() {
  const context = useContext(featureFlagContext);
  if (!context) {
    throw new Error(
      'featureFlagContext value is undefined. Make sure you use the FeatureFlagProvider before using the context.'
    );
  }
  return context;
}

export type IFeatureFlagContext = {
  featureFlagCache: ObjectMap;
  updateFeatureFlagCache: (newData: ObjectMap) => void;
};
